export default "__VITE_ASSET__BCE1YAA1__"